// src/services/AbilityService.js

export const AbilityService = {
  // Abilities
  async loadAbilities() {
    try {
      const res = await fetch("/abilities.json", { cache: "no-cache" });
      if (!res.ok) throw new Error("Not found");

      // 1) Pull in raw JSON
      const abilities = await res.json();

      // 2) Sort by element, then by type, then by numeric cost
      abilities.sort((a, b) => {
        // Compare element strings
        if (a.element < b.element) return -1;
        if (a.element > b.element) return 1;

        // Same element → compare type strings
        if (a.cardType < b.cardType) return -1;
        if (a.cardType > b.cardType) return 1;

        // Same element and type → compare costs numerically
        const costA = parseFloat(a.cost) || 0;
        const costB = parseFloat(b.cost) || 0;
        return costA - costB;
      });

      return abilities;
    } catch {
      return [];
    }
  },

  downloadJSON(abilities) {
    const payload = JSON.stringify(abilities, null, 2);
    const blob    = new Blob([payload], { type: "application/json" });
    const url     = URL.createObjectURL(blob);
    const a       = document.createElement("a");
    a.href        = url;
    a.download    = "abilities.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  },

  // Keywords
  async loadKeywords() {
    try {
      const res = await fetch("/keywords.json", { cache: "no-cache" });
      if (!res.ok) throw new Error("Not found");
      let kws = await res.json();
      // alphabetize by name
      return kws.sort((a, b) => a.name.localeCompare(b.name));
    } catch {
      return [];
    }
  },

  downloadKeywordsJSON(keywords) {
    const payload = JSON.stringify(keywords, null, 2);
    const blob    = new Blob([payload], { type: "application/json" });
    const url     = URL.createObjectURL(blob);
    const a       = document.createElement("a");
    a.href        = url;
    a.download    = "keywords.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
};
